import React from 'react';
import './index.scss';
import { useHistory } from 'react-router-dom';
import { BanknoteIcon } from '../../../assets/images/bk-wallet/icons.js';
import { ROUTES as _routes } from '../../constants/app-constants.js';
import useViewport from '../../hooks/useViewport.js';

const Charity = props => {
  const {
    disabled,
    checked,
    onChange,
    theme,
    data,
    isWalletComponent = false,
    walletAmount
  } = props;
  const history = useHistory();
  const { isMobile } = useViewport();

  const handleNavigateToTC = event => {
    event.preventDefault();
    history.push(isMobile ? _routes.TERMS_AND_CONDITIONS : _routes.TERMS);
  };
  return (
    <div className="charity_wrapper" data-theme={theme}>
      <div className="charity">
        <div className="charity__content">
          <label className="charity__label">
            <input
              type="checkbox"
              className="charity__checkbox"
              disabled={disabled}
              name="charity"
              id="charity"
              checked={checked}
              onChange={e => onChange(e)}
            />
            <span
              className={`charity__custom ${theme} ${
                checked ? '' : 'charity__custom_uncheck'
              } ${disabled ? 'charity__custom_disabled' : ''} `}
            />
          </label>
          <div className="charity__text">
            <div
              className={`charity__name ${
                isWalletComponent ? 'charity__wallet-text-name-con' : ''
              }`}
            >
              {data && data.product && data.product.name}
              {isWalletComponent && (
                <span className="charity__wallet-amount-con">
                  (<BanknoteIcon />
                  <span>{`${walletAmount} `} Available</span>)
                </span>
              )}
            </div>
            {!isWalletComponent ? (
              <div className="charity__description">
                In association with
                <a
                  href="https://www.roomtoread.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginLeft: '8px' }}
                >
                  Room to Read
                </a>
              </div>
            ) : (
              <div className="charity__description">
                <a
                  href={isMobile ? _routes.TERMS_AND_CONDITIONS : _routes.TERMS}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleNavigateToTC}
                  style={{ marginLeft: '8px' }}
                >
                  T&C apply.
                </a>
              </div>
            )}
          </div>
        </div>
        {!isWalletComponent && (
          <div className="charity__amount">
            ₹
            <span className="charity__currency">
              {data && data.product && data.product.price
                ? data.product.price
                : 0}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Charity;
